import { EXCH_ACT_PRIZE_INFO, NO_REPORT } from '../../config/url';
import { handleFormatRes, request, RespError } from '../../utils';
// import { ExchActidList, QualExchActidList, QualInfoList, CouponInfoList } from './types';
import { reportExchActPrizeInfoRes } from './report';
// 需要转成 int 型的 key 数组
const needParseIntKey = [
    'userLimit',
    'totalNum',
    'totalSendNum',
    'qualCnt',
    'dayLimit',
    'daySent',
    'qualProperty',
    'qualType',
    'userMaxCount',
    'canGet',
    'hasGot',
    'couponCnt',
    'userMonthLimit',
    'userMonthSent',
];
// 需要转成 date 型的 key 数组
const needParseDateKey = [
    'sysTime',
    'startTime',
    'endTime',
    'disStartTime',
    'disEndTime',
    'exchStartTime',
    'exchEndTime',
];
/**
 * 兑换活动奖品信息查询
 *
 * 查询兑换活动（任务奖品兑换活动）奖品信息
 *
 * 接口地址：`/app/task/exch_act_prize_info.cgi`
 *
 * 此接口elk分片上报
 *
 * @param exchActidList 兑换活动id列表
 * @param qualIdList 印花id列表
 * @param qryQualAct 	=1，兑换活动奖品为印花/资格时，继续查询消耗印花/资格的活动id和奖品；
 * 活动id保存在qualExchActidList数组，奖品分别保存在qualInfoList/couponInfoList数组
 * @param statUserCpn =1，输出用户优惠券统计信息；用户优惠券统计信息在couponInfoList数组输出
 * @returns
 */
export async function exchActPrizeInfo({ exchActidList, qualIdList, qryQualAct, statUserCpn, }) {
    // 参数格式化
    let params = {
        t: new Date().getTime(),
        qry_qual_act: qryQualAct || 0,
        stat_user_cpn: statUserCpn || 0,
    };
    try {
        if (exchActidList) {
            params = Object.assign({}, params, {
                exch_actid_list: JSON.stringify(Array.isArray(exchActidList) ? exchActidList : [exchActidList]),
            });
        }
        if (qualIdList) {
            params = Object.assign({}, params, {
                qual_id_list: JSON.stringify(Array.isArray(qualIdList) ? qualIdList : [qualIdList]),
            });
        }
        // 接口请求
        const result = await request.get(`${EXCH_ACT_PRIZE_INFO}?${NO_REPORT}`, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({ result, needParseIntKey, needParseDateKey });
                // 正常上报
                reportExchActPrizeInfoRes(res, params);
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        // 异常上报
        reportExchActPrizeInfoRes(error, params);
        throw error;
    }
}
